<template>
  <ModalDialog
    v-model="isShow"
    :blockBackgroundScroll="false"
    :targetClass="isEmbed ? 'submit-button' : null"
    :level="10"
    :hideCloseBtn="hideButton"
    @close="closeResultDialog()"
  >
    <div class="p-5" slot="dialog-content">
      <div
        v-if="innerHtml"
        v-html="formatContent(innerHtml, ...params)"
        @click="handleClickContent($event)"
      ></div>
      <h2 class="" v-if="!innerHtml && title">
        <span>{{ formatContent(title, ...params) }}</span>
      </h2>
      <!-- <hr v-if="!innerHtml"> -->
      <h4 class="result-message" v-if="!innerHtml && message">
        <p>{{ formatContent(message, ...params) }}</p>
      </h4>
      <hr v-if="!hideButton" />
      <button
        v-if="!hideButton"
        class="mylisting-button secondary-button"
        @click="closeResultDialog()"
        style=""
      >
        {{ closeLabel }}
      </button>
      <div
        class="additional-items"
        v-if="additionalFooter"
        v-html="additionalFooter"
      ></div>
    </div>
  </ModalDialog>
</template>
<script>
/* This component is used to show result dialog.
To show an result, call this.showResultDialog(resultObject)
Structure of resultObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/

import ModalDialog from "./ModalDialog";
import { mapGetters } from "vuex";

export default {
  name: "ResultDialog",
  data: function () {
    return {
      title: "",
      message: "",
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      innerHtml: null,
      additionalFooter: null,
      params: [],
      isShow: false,
      hideButton: false,
      noToast: false, // Always show dialog
      onClickContent: null,
    };
  },
  components: {
    ModalDialog,
  },
  computed: {
    ...mapGetters(["isAgent"]),
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
  },
  methods: {
    closeResultDialog() {
      this.isShow = false;
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showResultDialog(null);
    },
    handleClickContent(event) {
      if (this.onClickContent) {
        this.onClickContent(event.target && event.target.id);
      }
    },
  },
  created() {
    this.$store.watch(
      (state) => state.dialogs.resultDialog,
      (value) => {
        if (!value) {
          this.isShow = false;
          this.showResultDialog(null);
        } else {
          if (this.isShow) {
            return;
          }
          this.noToast = value.noToast;
          this.title = value.title;
          this.message = value.message;
          if (value.messageList) {
            this.messageList = value.messageList;
          }
          this.innerHtml = value.innerHtml;
          this.additionalFooter = value.additionalFooter;
          if (!value.closeLabel) {
            this.closeLabel = this.getLabelByKeys("BUTTONS.CLOSE");
          } else {
            this.closeLabel = value.closeLabel;
          }
          this.onCloseCallback = value.onCloseCallback;
          this.onCloseCallbackData = value.onCloseCallbackData;
          this.params = value.params ? value.params : [];
          this.onClickContent = value.onClickContent;
          this.hideButton = value.hideButton;
          const key = value.key;
          let isMultiLanguageCloseLabel = false;
          if (key) {
            const title = this.getLabelByKeys(`RESULT_DIALOGS.${key}.TITLE`);
            if (title) {
              this.title = title;
            }
            const message = this.getLabelByKeys(
              `RESULT_DIALOGS.${key}.MESSAGE`
            );
            if (message) {
              this.message = message;
            }
            const innerHtml = this.getLabelByKeys(
              `RESULT_DIALOGS.${key}.INNER_HTML`
            );
            if (innerHtml) {
              this.innerHtml = innerHtml;
            }
            const closeLabel = this.getLabelByKeys(
              `RESULT_DIALOGS.${key}.CLOSE_LABEL`
            );
            if (closeLabel) {
              this.closeLabel = closeLabel;
              isMultiLanguageCloseLabel = true;
            }
          }
          // Use multi-language for close label
          if (!isMultiLanguageCloseLabel) {
            const displayCloseLabel = this.getLabelByKeys(
              `BUTTONS.${this.closeLabel.toUpperCase()}`
            );
            if (displayCloseLabel) {
              this.closeLabel = displayCloseLabel;
            }
          }
          if (this.isAgent && !this.noToast) {
            // For the simple result dialog to show to admin, use toast instead of dialog
            if (
              this.title &&
              !this.message &&
              !this.innerHtml &&
              !this.onCloseCallback
            ) {
              this.$toasted.show(this.formatContent(this.title, ...this.params));
              this.showResultDialog(null);
              return;
            }
          }
          this.isShow = true;
        }
      },
      { immediate: true }
    );
  },
};
</script>

<style scoped>
.additional-items {
  display: inline;
}

.result-message {
  margin-top: 1em;
  white-space: pre-wrap;
  /* margin-bottom: 1.5em !important; */
}

@media (max-width: 768px) {
  h2 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/global-dialogs/ResultDialog.vue